var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"noticia"}},[_c('Banner',{attrs:{"imagem":_vm.noticia.topo_link}}),_c('Conteudo',{attrs:{"noticia":_vm.noticia}}),_c('Listagem',{attrs:{"listagem":_vm.listagem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }